'use strict';

module.exports = {
    GetStyleInfoByLayeredArcRating: getStyleInfoByLayeredArcRating,
    GetStyleInfoByStyleAndRating: getStyleInfoByStyleAndRating,
    GetStyleInfoByStyle: getStyleInfoByStyle,
    GetStyleInfoByProductTypeAndRating: getStyleInfoByProductTypeAndRating,
    GetStyleInfoByProductType: getStyleInfoByProductType,
    CreateBaseStyleInfo: createBaseStyleInfo
}

/* ***** Private Functions ***** */
function copyStyleInfo(originalStyleInfo, includeBaseStyles, distinctProductInfos) {
    var copiedStyleInfo = createBaseStyleInfo(originalStyleInfo.Style, originalStyleInfo.Collection, originalStyleInfo.SafetyStandard,
        originalStyleInfo.ProductType, originalStyleInfo.AtpArcRating, originalStyleInfo.EbtArcRating);
    copiedStyleInfo.BaseStyleInfos = {};

    if (includeBaseStyles) {
        var baseStyleKeys = Object.keys(originalStyleInfo.BaseStyleInfos);
        for (var baseIndex = 0; baseIndex < baseStyleKeys.length; baseIndex++) {
            var baseStyleKey = baseStyleKeys[baseIndex];
            copiedStyleInfo.BaseStyleInfos[baseStyleKey] = originalStyleInfo.BaseStyleInfos[baseStyleKey];
            copiedStyleInfo.BaseStyleInfos[baseStyleKey].ProductInfo = distinctProductInfos[baseStyleKey];
        }
    }

    return copiedStyleInfo;
}

/*	Creates the base StyleInfo JSON object that is the same whether the style is at the
	Outer or Inner (aka Base) layer.
	When complete, the OuterStyleInfo will have an object containing a collection of all of it's "Base" styles.
	When complete, the BaseStyleInfo will have a property called "LayeredArcRating" with the value for when the outer is over it. */
function createBaseStyleInfo(style, collection, safetyStandard, productType, atpArcRating, ebtArcRating) {
    return {
        Style: style,
        Collection: collection,
        SafetyStandard: safetyStandard,
        ProductType: productType,
        AtpArcRating: atpArcRating,
        EbtArcRating: ebtArcRating
    };
}

function getOtherStyleInfoWithBaseStyle(outerStyleInfos, distinctProductInfos, container, style) {
    // e.g. style could be 'CLB2'
    var outerStyleKeys = Object.keys(outerStyleInfos);
    for (var outerIndex = 0; outerIndex < outerStyleKeys.length; outerIndex++) {
        var copiedOuterStyleInfo = null;
        var outerStyleKey = outerStyleKeys[outerIndex];
        if (outerStyleKey !== style) {
            // e.g. The outerStyleInfos processed will be all the rest of them (excluding 'CLB2'), 'SLS2', 'SLU2', etc.
            var outerStyleInfo = outerStyleInfos[outerStyleKey];
            var baseStyleKeys = Object.keys(outerStyleInfo.BaseStyleInfos);
            for (var baseIndex = 0; baseIndex < baseStyleKeys.length; baseIndex++) {
                var baseStyleKey = baseStyleKeys[baseIndex];
                var baseStyleInfo = outerStyleInfo.BaseStyleInfos[baseStyleKey];
                if (baseStyleInfo.Style === style) {
                    // NOTE: We only want baseStyles that match the given style.
                    if (copiedOuterStyleInfo === null) {
                        copiedOuterStyleInfo = createBaseStyleInfo(outerStyleInfo.Style, outerStyleInfo.Collection, outerStyleInfo.SafetyStandard,
                            outerStyleInfo.ProductType, outerStyleInfo.AtpArcRating, outerStyleInfo.EbtArcRating);
                        copiedOuterStyleInfo.BaseStyleInfos = {};
                    }

                    baseStyleInfo.ProductInfo = distinctProductInfos[baseStyleKey];
                    copiedOuterStyleInfo.BaseStyleInfos[baseStyleKey] = baseStyleInfo;
                }
            }
        }

        if (copiedOuterStyleInfo !== null) {
            container.OuterStyleInfos[outerStyleKey] = copiedOuterStyleInfo;
            container.OuterStyleInfos[outerStyleKey].ProductInfo = distinctProductInfos[outerStyleKey];
        }
    }
}

function getStyleInfoByLayeredArcRating(layeredArcRating, ratingModifier, outerStyleInfos, distinctProductInfos) {
    var container = { OuterStyleInfos: {} };
    var layeredRatingNumber = new Number(layeredArcRating);
    var maxLayeredArcRating = layeredRatingNumber + ratingModifier;

    var outerStyleKeys = Object.keys(outerStyleInfos);
    for (var outerIndex = 0; outerIndex < outerStyleKeys.length; outerIndex++) {
        var outerStyleKey = outerStyleKeys[outerIndex];
        var outerStyleInfo = outerStyleInfos[outerStyleKey];
        var copiedOuterStyleInfo = null;

        // Iterate over the BaseStyles of this outer so we can return any that are of the correct Layered Arc Rating
        var baseStyleKeys = Object.keys(outerStyleInfo.BaseStyleInfos);
        for (var baseIndex = 0; baseIndex < baseStyleKeys.length; baseIndex++) {
            var baseStyleKey = baseStyleKeys[baseIndex];
            var baseStyleInfo = outerStyleInfo.BaseStyleInfos[baseStyleKey];
            if (baseStyleInfo.LayeredArcRating >= layeredArcRating && baseStyleInfo.LayeredArcRating <= maxLayeredArcRating) {
                if (copiedOuterStyleInfo === null) {
                    copiedOuterStyleInfo = createBaseStyleInfo(outerStyleInfo.Style, outerStyleInfo.Collection, outerStyleInfo.SafetyStandard,
                        outerStyleInfo.ProductType, outerStyleInfo.AtpArcRating, outerStyleInfo.EbtArcRating);
                    copiedOuterStyleInfo.BaseStyleInfos = {};
                }

                baseStyleInfo.ProductInfo = distinctProductInfos[baseStyleKey];
                copiedOuterStyleInfo.BaseStyleInfos[baseStyleKey] = baseStyleInfo;
            }
        }

        if (copiedOuterStyleInfo !== null) {
            container.OuterStyleInfos[outerStyleKey] = copiedOuterStyleInfo;
            container.OuterStyleInfos[outerStyleKey].ProductInfo = distinctProductInfos[outerStyleKey];
        }
    }

    return container;
}

function getStyleInfoByStyleAndRating(style, layeredArcRating, ratingModifier, outerStyleInfos, distinctProductInfos) {
    var styleContainer = getStyleInfoByStyle(style, outerStyleInfos, distinctProductInfos);
    var container = getStyleInfoByLayeredArcRating(layeredArcRating, ratingModifier, styleContainer.OuterStyleInfos, distinctProductInfos);

    return container;
}

/*	Returns a new container object with an "OuterStyleInfos" property.
	Within that will be the OuterStyle that matches the given style
	and all of the other available OuterStyles that have a Base layer that
	matches the given style. */
function getStyleInfoByStyle(style, outerStyleInfos, distinctProductInfos) {
    var container = { OuterStyleInfos: {} };
    var originalStyleInfo = outerStyleInfos[style];

    if (originalStyleInfo) {
        var copiedStyleInfo = copyStyleInfo(originalStyleInfo, true, distinctProductInfos);
        container.OuterStyleInfos[style] = copiedStyleInfo;
        container.OuterStyleInfos[style].ProductInfo = distinctProductInfos[style];
    }

    getOtherStyleInfoWithBaseStyle(outerStyleInfos, distinctProductInfos, container, style);

    return container;
}

function getStyleInfoByProductTypeAndRating(productTypeId, layeredArcRating, ratingModifier, outerStyleInfos, distinctProductInfos) {
    var productTypeContainer = getStyleInfoByProductType(productTypeId, outerStyleInfos, distinctProductInfos);
    var container = getStyleInfoByLayeredArcRating(layeredArcRating, ratingModifier, productTypeContainer.OuterStyleInfos, distinctProductInfos);

    return container;
}

/*	Returns a new container object with an "OuterStyleInfos" property.
	Within that will be all the OuterStyles that matches the given productType
	and all of the other available OuterStyles that have a Base layer that
	matches the given productType. */
function getStyleInfoByProductType(productTypeId, outerStyleInfos, distinctProductInfos) {
    var container = { OuterStyleInfos: {} };

    var outerStyleKeys = Object.keys(outerStyleInfos);
    for (var outerIndex = 0; outerIndex < outerStyleKeys.length; outerIndex++) {
        var outerStyleKey = outerStyleKeys[outerIndex];
        var outerStyleInfo = outerStyleInfos[outerStyleKey];
        var copiedOuterStyleInfo = null;

        if (outerStyleInfo.ProductType.Id === productTypeId) {
            var copiedStyleInfo = copyStyleInfo(outerStyleInfo, true, distinctProductInfos);
            container.OuterStyleInfos[outerStyleKey] = copiedStyleInfo;
            container.OuterStyleInfos[outerStyleKey].ProductInfo = distinctProductInfos[outerStyleKey];
        } else {
            // In this case, the outerStyle is NOT the desired ProductType.
            // Iterate over the BaseStyles of this outer so we can return any that are of the correct ProductType
            var baseStyleKeys = Object.keys(outerStyleInfo.BaseStyleInfos);
            for (var baseIndex = 0; baseIndex < baseStyleKeys.length; baseIndex++) {
                var baseStyleKey = baseStyleKeys[baseIndex];
                var baseStyleInfo = outerStyleInfo.BaseStyleInfos[baseStyleKey];
                if (baseStyleInfo.ProductType.Id === productTypeId) {
                    // NOTE: We only want baseStyles that match the given productType
                    if (copiedOuterStyleInfo === null) {
                        copiedOuterStyleInfo = createBaseStyleInfo(outerStyleInfo.Style, outerStyleInfo.Collection, outerStyleInfo.SafetyStandard,
                            outerStyleInfo.ProductType, outerStyleInfo.AtpArcRating, outerStyleInfo.EbtArcRating);
                        copiedOuterStyleInfo.BaseStyleInfos = {};
                    }

                    baseStyleInfo.ProductInfo = distinctProductInfos[baseStyleKey];
                    copiedOuterStyleInfo.BaseStyleInfos[baseStyleKey] = baseStyleInfo;
                }
            }

            if (copiedOuterStyleInfo !== null) {
                container.OuterStyleInfos[outerStyleKey] = copiedOuterStyleInfo;
                container.OuterStyleInfos[outerStyleKey].ProductInfo = distinctProductInfos[outerStyleKey];
            }
        }
    }

    return container;
}
